// extracted by mini-css-extract-plugin
export default {"FullWidthSection":"FullWidthSection_FullWidthSection__agG9f"};